import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IRootState } from '../store';
import { usePermission } from '../hooks/usePermission';
import CapitalSpinner from '@/components/CapitalSpinner';

interface ProtectedRouteProps {
    permission?: string;
    anyOf?: string[];
    role?: string;
    children: ReactNode;
}

const ProtectedRoute = ({ permission, anyOf, role, children }: ProtectedRouteProps) => {
    const location = useLocation();
    const { user, initialized } = useSelector((s: IRootState) => s.auth);
    const { hasPermission, hasAnyPermission, hasRole } = usePermission();

    // Sem sessão em cache, espera o /api/me. Com cache, renderiza já: o fetchMe
    // confirma em background e, num 401, zera `user` e cai no redirect abaixo.
    if (!initialized && !user) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <CapitalSpinner size={48} />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.must_change_password && location.pathname !== '/change-password') {
        return <Navigate to="/change-password" replace />;
    }

    let allowed = true;
    if (permission) allowed = allowed && hasPermission(permission);
    if (anyOf) allowed = allowed && hasAnyPermission(anyOf);
    if (role) allowed = allowed && hasRole(role);

    if (!allowed) {
        return <Navigate to="/forbidden" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
